import { IS_WEB } from './platform';

/**
 * Yerel bir dosya yolunu `<audio src>` içinde kullanılabilir bir file:// URL'ine
 * çevirir.
 *
 * Eski kod `file://${path.replace(/\\/g,'/')}` yazıyordu; bu iki yerde
 * bozuluyordu:
 *  - Windows yolunda üçüncü eğik çizgi eksikti (`file://C:/...` yerine
 *    `file:///C:/...` olmalı) — aksi hâlde "C:" ana makine adı sanılıyor.
 *  - Boşluklar kodlanmıyordu; varsayılan kayıt klasörü "Zabit Kayitlari"
 *    olduğu için her kayıt bundan etkileniyordu.
 *
 * Web uygulamasında "yerel dosya" tarayıcı deposundaki bir kayıt (`idb:…`);
 * adresi köprü veriyor (`blob:`). Bu tarayıcıda değilse boş döner — oynatıcı
 * gizlenir, kayıt buluta arşivlenince oradan çalınır.
 */
export function toFileUrl(filePath: string): string {
  if (IS_WEB) return window.zabit.localAudioUrl?.(filePath) ?? '';

  const normalized = filePath.replace(/\\/g, '/');
  const absolute = normalized.startsWith('/') ? normalized : `/${normalized}`;

  // encodeURI `:` ve `/` karakterlerine dokunmaz ama boşluğu kodlar.
  // `#` ve `?` URI'de özel anlam taşıdığı için elle kodlanıyor.
  return encodeURI(`file://${absolute}`).replace(/#/g, '%23').replace(/\?/g, '%3F');
}
